/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_CommercialInputs */

const en_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commercial`)
};

const es_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comercial`)
};

const fr_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commercial`)
};

const de_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gewerbe`)
};

const ja_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商業用`)
};

const zh_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商业`)
};

const ar_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تجاري`)
};

const id_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komersial`)
};

const it_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commerciale`)
};

const ru_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Коммерческая недвижимость`)
};

const pt_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comercial`)
};

const ko_val_commercial = /** @type {(inputs: Val_CommercialInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`상업용`)
};

/**
* | output |
* | --- |
* | "Commercial" |
*
* @param {Val_CommercialInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_commercial = /** @type {((inputs?: Val_CommercialInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_CommercialInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_commercial(inputs)
	if (locale === "es") return es_val_commercial(inputs)
	if (locale === "fr") return fr_val_commercial(inputs)
	if (locale === "de") return de_val_commercial(inputs)
	if (locale === "ja") return ja_val_commercial(inputs)
	if (locale === "zh") return zh_val_commercial(inputs)
	if (locale === "ar") return ar_val_commercial(inputs)
	if (locale === "id") return id_val_commercial(inputs)
	if (locale === "it") return it_val_commercial(inputs)
	if (locale === "ru") return ru_val_commercial(inputs)
	if (locale === "pt") return pt_val_commercial(inputs)
	return ko_val_commercial(inputs)
});